import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Data payload for creating an AVP chart.
 */
export type AvpChartCreateData = {
	/**
	 * The ARI of the AVP dashboard to create the chart on.
	 */
	dashboardAri: string;
	/**
	 * The chart data containing chart configuration and canvas layout.
	 */
	chartData: {
		/**
		 * The JSON-stringified chart configuration.
		 */
		chart: SerializableValue;
		/**
		 * The JSON-stringified canvas layout configuration.
		 */
		canvasLayout: SerializableValue;
	};
};

/**
 * Properties for the AVP chart creation command.
 *
 * @extends CommandProperties
 */
export interface AvpChartCreateCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the chart creation request.
	 */
	key: string;
	/**
	 * The data payload containing the content for the new chart.
	 */
	data: AvpChartCreateData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}

/**
 * A command sent by a bridge API client to create a new AVP chart.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create an AVP chart with the specified configuration.
 */
export const AvpChartCreateCommand: CommandConstructor<
	AvpChartCreateCommandProperties,
	SerializableValue
> = createCommand<AvpChartCreateCommandProperties>('avp-chart-create-command');
